import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";

import { useAdminContext } from "../../../../contexts/AdminContext";

export default function Filters({ keyword, setKeyword }) {
  const { dispatch, actions, state } = useAdminContext();

  return (
    <div className="invite_search">
      <Row>
        <Col md={3}>
          <form className="inviteSearch_form">
            <input
              type="text"
              placeholder="Search Admin"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
          </form>
        </Col>
        <Col md={9} className="text-right">
          <Button
            onClick={() => actions.showCreateForm(dispatch)}
            bsStyle="primary"
          >
            Add Admin
          </Button>
        </Col>
      </Row>
    </div>
  );
}
